var $b547c8d8406f682e$exports = {};
const $b547c8d8406f682e$var$state = {
    attendees: [],
    columns: {
        firstName: null,
        lastName: null,
        pronouns: null,
        role: null
    },
    fileName: '',
    formatId: '1x2.625-30',
    sheetOffsetX: 0,
    sheetOffsetY: 0,
    labelWidthAdjust: 0,
    labelHeightAdjust: 0,
    stickerOffset: 0,
    columnGapMm: 6.35,
    rowGapMm: 0,
    nameFontSize: 18,
    pronounsFontSize: 14,
    roleFontSize: 12,
    showBorders: true,
    savedPresets: []
};
const $b547c8d8406f682e$var$labelSortCollator = new Intl.Collator(undefined, {
    sensitivity: 'base',
    numeric: true
});
const $b547c8d8406f682e$var$LABEL_FORMATS = {
    '1x2.625-30': {
        label: '1"x2-5/8"(30 up)',
        perSheet: 30,
        columns: 3,
        pageWidth: '8.5in',
        pageHeight: '11in',
        sheetPadding: '0.5in 0',
        labelWidth: '2.625in',
        labelHeight: '1in',
        columnGap: '0.25in',
        rowGap: '0',
        labelPadding: '0.08in 0.12in',
        labelContentGap: '0.04in',
        labelOffsetX: '0',
        labelOffsetY: '0',
        nameFontSize: '18px',
        pronounsFontSize: '14px',
        roleFontSize: '12px'
    },
    '2x4-10': {
        label: '2"x4"(10 up)',
        perSheet: 10,
        columns: 2,
        pageWidth: '8.5in',
        pageHeight: '11in',
        sheetPadding: '0.5in 0.25in',
        labelWidth: '4in',
        labelHeight: '2in',
        columnGap: '0',
        rowGap: '0',
        labelPadding: '0.18in 0.22in',
        labelContentGap: '0.08in',
        labelOffsetX: '0',
        labelOffsetY: '0',
        nameFontSize: '28px',
        pronounsFontSize: '20px',
        roleFontSize: '18px'
    },
    '8.5x5.5-2': {
        label: '8.5"x5.5"(2 up)',
        perSheet: 2,
        columns: 1,
        pageWidth: '8.5in',
        pageHeight: '11in',
        sheetPadding: '0',
        labelWidth: '8.5in',
        labelHeight: '5.5in',
        columnGap: 0,
        rowGap: 0,
        labelPadding: '0.42in 0.5in',
        labelContentGap: '0.14in',
        labelOffsetX: '0',
        labelOffsetY: '0',
        nameFontSize: '48px',
        pronounsFontSize: '30px',
        roleFontSize: '24px'
    },
    '8.5x11-1': {
        label: '8.5"x11"(1 up)',
        perSheet: 1,
        columns: 1,
        pageWidth: '8.5in',
        pageHeight: '11in',
        sheetPadding: '0',
        labelWidth: '8.5in',
        labelHeight: '11in',
        columnGap: 0,
        rowGap: 0,
        labelPadding: '0.75in 0.67in',
        labelContentGap: '0.18in',
        labelOffsetX: '0',
        labelOffsetY: '0',
        nameFontSize: '64px',
        pronounsFontSize: '40px',
        roleFontSize: '30px'
    }
};
const $b547c8d8406f682e$var$elements = {
    fileInput: document.getElementById('csv-file-input'),
    dropzone: document.getElementById('csv-dropzone'),
    formatSelect: document.getElementById('label-format-select'),
    sheetOffsetXInput: document.getElementById('sheet-offset-x'),
    sheetOffsetYInput: document.getElementById('sheet-offset-y'),
    labelWidthAdjustInput: document.getElementById('label-width-adjust'),
    labelHeightAdjustInput: document.getElementById('label-height-adjust'),
    stickerOffsetInput: document.getElementById('sticker-offset'),
    columnGapInput: document.getElementById('column-gap'),
    rowGapInput: document.getElementById('row-gap'),
    nameFontSizeInput: document.getElementById('name-font-size'),
    pronounsFontSizeInput: document.getElementById('pronouns-font-size'),
    roleFontSizeInput: document.getElementById('role-font-size'),
    showBordersInput: document.getElementById('show-borders'),
    savedSettingsSelect: document.getElementById('saved-settings-select'),
    applySettingsButton: document.getElementById('apply-settings-button'),
    saveSettingsButton: document.getElementById('save-settings-button'),
    saveSettingsDialog: document.getElementById('save-settings-dialog'),
    saveSettingsForm: document.getElementById('save-settings-form'),
    saveSettingsNameInput: document.getElementById('save-settings-name'),
    cancelSaveSettingsButton: document.getElementById('cancel-save-settings-button'),
    printButton: document.getElementById('print-button'),
    fileNamePill: document.getElementById('file-name-pill'),
    metricTotal: document.getElementById('metric-total'),
    metricWithRole: document.getElementById('metric-with-role'),
    metricWithoutRole: document.getElementById('metric-without-role'),
    detectedColumns: document.getElementById('detected-columns'),
    previewTableBody: document.getElementById('preview-table-body'),
    printGrid: document.getElementById('print-grid')
};
const $b547c8d8406f682e$var$HEADER_ALIASES = {
    firstName: [
        'firstname',
        'first_name',
        'first name',
        'prenom',
        "pr\xe9nom",
        'givenname',
        'given name'
    ],
    lastName: [
        'lastname',
        'last_name',
        'last name',
        'surname',
        'familyname',
        'family name',
        'nom'
    ],
    pronouns: [
        'pronoms',
        'pronom',
        'pronouns',
        'pronoun',
        'preferred pronouns'
    ],
    role: [
        'role',
        'job',
        'title',
        'position',
        'poste',
        'emploi',
        'occupation'
    ]
};
const $b547c8d8406f682e$var$SETTINGS_COOKIE_NAME = 'evenix_csv_printer_settings';
const $b547c8d8406f682e$var$SETTINGS_PRESETS_COOKIE_NAME = 'evenix_csv_printer_presets';
const $b547c8d8406f682e$var$SETTINGS_COOKIE_MAX_AGE = 15552000;
function $b547c8d8406f682e$var$readCookie(name) {
    const cookiePrefix = `${name}=`;
    const cookie = document.cookie.split(';').map((value)=>value.trim()).find((value)=>value.startsWith(cookiePrefix));
    return cookie ? cookie.slice(cookiePrefix.length) : null;
}
function $b547c8d8406f682e$var$writeCookie(name, value, maxAgeSeconds) {
    document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}; samesite=lax`;
}
function $b547c8d8406f682e$var$getSettingsPayload() {
    return {
        formatId: $b547c8d8406f682e$var$state.formatId,
        sheetOffsetX: $b547c8d8406f682e$var$state.sheetOffsetX,
        sheetOffsetY: $b547c8d8406f682e$var$state.sheetOffsetY,
        labelWidthAdjust: $b547c8d8406f682e$var$state.labelWidthAdjust,
        labelHeightAdjust: $b547c8d8406f682e$var$state.labelHeightAdjust,
        columnGapMm: $b547c8d8406f682e$var$state.columnGapMm,
        rowGapMm: $b547c8d8406f682e$var$state.rowGapMm,
        nameFontSize: $b547c8d8406f682e$var$state.nameFontSize,
        pronounsFontSize: $b547c8d8406f682e$var$state.pronounsFontSize,
        roleFontSize: $b547c8d8406f682e$var$state.roleFontSize,
        showBorders: $b547c8d8406f682e$var$state.showBorders
    };
}
function $b547c8d8406f682e$var$syncSettingsInputs() {
    $b547c8d8406f682e$var$elements.formatSelect.value = $b547c8d8406f682e$var$state.formatId;
    $b547c8d8406f682e$var$elements.sheetOffsetXInput.value = `${$b547c8d8406f682e$var$state.sheetOffsetX}`;
    $b547c8d8406f682e$var$elements.sheetOffsetYInput.value = `${$b547c8d8406f682e$var$state.sheetOffsetY}`;
    $b547c8d8406f682e$var$elements.labelWidthAdjustInput.value = `${$b547c8d8406f682e$var$state.labelWidthAdjust}`;
    $b547c8d8406f682e$var$elements.labelHeightAdjustInput.value = `${$b547c8d8406f682e$var$state.labelHeightAdjust}`;
    $b547c8d8406f682e$var$elements.stickerOffsetInput.value = `${$b547c8d8406f682e$var$state.stickerOffset}`;
    $b547c8d8406f682e$var$elements.columnGapInput.value = `${$b547c8d8406f682e$var$state.columnGapMm}`;
    $b547c8d8406f682e$var$elements.rowGapInput.value = `${$b547c8d8406f682e$var$state.rowGapMm}`;
    $b547c8d8406f682e$var$elements.nameFontSizeInput.value = `${$b547c8d8406f682e$var$state.nameFontSize}`;
    $b547c8d8406f682e$var$elements.pronounsFontSizeInput.value = `${$b547c8d8406f682e$var$state.pronounsFontSize}`;
    $b547c8d8406f682e$var$elements.roleFontSizeInput.value = `${$b547c8d8406f682e$var$state.roleFontSize}`;
    $b547c8d8406f682e$var$elements.showBordersInput.checked = $b547c8d8406f682e$var$state.showBorders;
}
function $b547c8d8406f682e$var$setSettingsFromPayload(payload) {
    const resolvedFormatId = typeof payload.formatId === 'string' && $b547c8d8406f682e$var$LABEL_FORMATS[payload.formatId] ? payload.formatId : $b547c8d8406f682e$var$state.formatId;
    const resolvedFormat = $b547c8d8406f682e$var$LABEL_FORMATS[resolvedFormatId];
    $b547c8d8406f682e$var$state.formatId = resolvedFormatId;
    $b547c8d8406f682e$var$state.sheetOffsetX = $b547c8d8406f682e$var$getSheetOffsetValue(payload.sheetOffsetX);
    $b547c8d8406f682e$var$state.sheetOffsetY = $b547c8d8406f682e$var$getSheetOffsetValue(payload.sheetOffsetY);
    $b547c8d8406f682e$var$state.labelWidthAdjust = $b547c8d8406f682e$var$getSheetOffsetValue(payload.labelWidthAdjust);
    $b547c8d8406f682e$var$state.labelHeightAdjust = $b547c8d8406f682e$var$getSheetOffsetValue(payload.labelHeightAdjust);
    $b547c8d8406f682e$var$state.columnGapMm = $b547c8d8406f682e$var$getSheetOffsetValue(payload.columnGapMm !== undefined ? payload.columnGapMm : $b547c8d8406f682e$var$getMillimeterValue(resolvedFormat.columnGap));
    $b547c8d8406f682e$var$state.rowGapMm = $b547c8d8406f682e$var$getSheetOffsetValue(payload.rowGapMm !== undefined ? payload.rowGapMm : $b547c8d8406f682e$var$getMillimeterValue(resolvedFormat.rowGap));
    $b547c8d8406f682e$var$state.nameFontSize = $b547c8d8406f682e$var$getSheetOffsetValue(payload.nameFontSize !== undefined ? payload.nameFontSize : $b547c8d8406f682e$var$getPixelValue(resolvedFormat.nameFontSize));
    $b547c8d8406f682e$var$state.pronounsFontSize = $b547c8d8406f682e$var$getSheetOffsetValue(payload.pronounsFontSize !== undefined ? payload.pronounsFontSize : $b547c8d8406f682e$var$getPixelValue(resolvedFormat.pronounsFontSize));
    $b547c8d8406f682e$var$state.roleFontSize = $b547c8d8406f682e$var$getSheetOffsetValue(payload.roleFontSize !== undefined ? payload.roleFontSize : $b547c8d8406f682e$var$getPixelValue(resolvedFormat.roleFontSize));
    $b547c8d8406f682e$var$state.showBorders = payload.showBorders !== undefined ? Boolean(payload.showBorders) : true;
}
function $b547c8d8406f682e$var$renderSavedPresetOptions() {
    const defaultOption = '<option value="">Select a saved setup</option>';
    const presetOptions = $b547c8d8406f682e$var$state.savedPresets.slice().sort((left, right)=>$b547c8d8406f682e$var$labelSortCollator.compare(left.name, right.name)).map((preset)=>`<option value="${$b547c8d8406f682e$var$escapeHtml(preset.name)}">${$b547c8d8406f682e$var$escapeHtml(preset.name)}</option>`).join('');
    $b547c8d8406f682e$var$elements.savedSettingsSelect.innerHTML = `${defaultOption}${presetOptions}`;
    $b547c8d8406f682e$var$elements.applySettingsButton.disabled = !$b547c8d8406f682e$var$state.savedPresets.length;
}
function $b547c8d8406f682e$var$persistSettings() {
    $b547c8d8406f682e$var$writeCookie($b547c8d8406f682e$var$SETTINGS_COOKIE_NAME, encodeURIComponent(JSON.stringify($b547c8d8406f682e$var$getSettingsPayload())), $b547c8d8406f682e$var$SETTINGS_COOKIE_MAX_AGE);
}
function $b547c8d8406f682e$var$persistSavedPresets() {
    $b547c8d8406f682e$var$writeCookie($b547c8d8406f682e$var$SETTINGS_PRESETS_COOKIE_NAME, encodeURIComponent(JSON.stringify($b547c8d8406f682e$var$state.savedPresets)), $b547c8d8406f682e$var$SETTINGS_COOKIE_MAX_AGE);
}
function $b547c8d8406f682e$var$restoreSavedPresets() {
    const rawCookie = $b547c8d8406f682e$var$readCookie($b547c8d8406f682e$var$SETTINGS_PRESETS_COOKIE_NAME);
    if (!rawCookie) {
        $b547c8d8406f682e$var$renderSavedPresetOptions();
        return;
    }
    try {
        const savedPresets = JSON.parse(decodeURIComponent(rawCookie));
        $b547c8d8406f682e$var$state.savedPresets = Array.isArray(savedPresets) ? savedPresets.filter((preset)=>preset && typeof preset.name === 'string' && preset.settings) : [];
    } catch (error) {
        $b547c8d8406f682e$var$state.savedPresets = [];
        $b547c8d8406f682e$var$writeCookie($b547c8d8406f682e$var$SETTINGS_PRESETS_COOKIE_NAME, '', 0);
    }
    $b547c8d8406f682e$var$renderSavedPresetOptions();
}
function $b547c8d8406f682e$var$restoreSettings() {
    const rawCookie = $b547c8d8406f682e$var$readCookie($b547c8d8406f682e$var$SETTINGS_COOKIE_NAME);
    const defaultFormat = $b547c8d8406f682e$var$getSelectedFormat();
    if (!rawCookie) {
        $b547c8d8406f682e$var$state.columnGapMm = $b547c8d8406f682e$var$getMillimeterValue(defaultFormat.columnGap);
        $b547c8d8406f682e$var$state.rowGapMm = $b547c8d8406f682e$var$getMillimeterValue(defaultFormat.rowGap);
        $b547c8d8406f682e$var$state.nameFontSize = $b547c8d8406f682e$var$getPixelValue(defaultFormat.nameFontSize);
        $b547c8d8406f682e$var$state.pronounsFontSize = $b547c8d8406f682e$var$getPixelValue(defaultFormat.pronounsFontSize);
        $b547c8d8406f682e$var$state.roleFontSize = $b547c8d8406f682e$var$getPixelValue(defaultFormat.roleFontSize);
        $b547c8d8406f682e$var$syncSettingsInputs();
        return;
    }
    try {
        const savedSettings = JSON.parse(decodeURIComponent(rawCookie));
        $b547c8d8406f682e$var$setSettingsFromPayload(savedSettings);
    } catch (error) {
        $b547c8d8406f682e$var$writeCookie($b547c8d8406f682e$var$SETTINGS_COOKIE_NAME, '', 0);
    }
    $b547c8d8406f682e$var$syncSettingsInputs();
}
function $b547c8d8406f682e$var$normalizeHeader(value) {
    return value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
}
function $b547c8d8406f682e$var$titleCase(value) {
    return value.toLowerCase().split(/\s+/).filter(Boolean).map((part)=>part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
}
function $b547c8d8406f682e$var$escapeHtml(value) {
    return value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
}
function $b547c8d8406f682e$var$sortAttendees(attendees) {
    return [
        ...attendees
    ].sort((left, right)=>{
        const leftPrimaryName = left.lastName || left.firstName;
        const rightPrimaryName = right.lastName || right.firstName;
        const primaryNameComparison = $b547c8d8406f682e$var$labelSortCollator.compare(leftPrimaryName, rightPrimaryName);
        if (primaryNameComparison !== 0) return primaryNameComparison;
        const leftSecondaryName = left.lastName ? left.firstName : left.lastName;
        const rightSecondaryName = right.lastName ? right.firstName : right.lastName;
        const secondaryNameComparison = $b547c8d8406f682e$var$labelSortCollator.compare(leftSecondaryName, rightSecondaryName);
        if (secondaryNameComparison !== 0) return secondaryNameComparison;
        return $b547c8d8406f682e$var$labelSortCollator.compare(left.role, right.role);
    });
}
function $b547c8d8406f682e$var$getDisplayName(attendee) {
    return [
        attendee.firstName,
        attendee.lastName
    ].filter(Boolean).join(' ');
}
function $b547c8d8406f682e$var$getDisplayPronouns(attendee) {
    if (!attendee.pronouns) return '';
    return `(${attendee.pronouns})`;
}
function $b547c8d8406f682e$var$chunkAttendees(attendees, chunkSize) {
    const chunks = [];
    for(let index = 0; index < attendees.length; index += chunkSize)chunks.push(attendees.slice(index, index + chunkSize));
    return chunks;
}
function $b547c8d8406f682e$var$getSelectedFormat() {
    return $b547c8d8406f682e$var$LABEL_FORMATS[$b547c8d8406f682e$var$state.formatId] || $b547c8d8406f682e$var$LABEL_FORMATS['1x2.625-30'];
}
function $b547c8d8406f682e$var$getSheetOffsetValue(value) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
}
function $b547c8d8406f682e$var$getStickerOffsetValue(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
}
function $b547c8d8406f682e$var$getAdjustedDimension(baseDimension, adjustment) {
    if (!adjustment) return baseDimension;
    return `calc(${baseDimension} + ${adjustment}mm)`;
}
function $b547c8d8406f682e$var$getPixelValue(value) {
    if (typeof value === 'number') return value;
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
}
function $b547c8d8406f682e$var$getMillimeterValue(value) {
    if (typeof value === 'number') return value;
    const stringValue = `${value}`.trim();
    const parsed = Number.parseFloat(stringValue);
    if (!Number.isFinite(parsed)) return 0;
    if (stringValue.endsWith('in')) return Number((parsed * 25.4).toFixed(2));
    if (stringValue.endsWith('px')) return Number((parsed * 25.4 / 96).toFixed(2));
    return parsed;
}
function $b547c8d8406f682e$var$detectDelimiter(text) {
    const sample = text.split(/\r?\n/).slice(0, 5).join('\n');
    const delimiters = [
        ',',
        ';',
        '\t'
    ];
    let bestDelimiter = ',';
    let bestScore = -1;
    delimiters.forEach((delimiter)=>{
        const score = sample.split(delimiter).length;
        if (score > bestScore) {
            bestScore = score;
            bestDelimiter = delimiter;
        }
    });
    return bestDelimiter;
}
function $b547c8d8406f682e$var$parseCsv(text) {
    const delimiter = $b547c8d8406f682e$var$detectDelimiter(text);
    const rows = [];
    let currentCell = '';
    let currentRow = [];
    let insideQuotes = false;
    for(let index = 0; index < text.length; index += 1){
        const character = text[index];
        const nextCharacter = text[index + 1];
        if (character === '"') {
            if (insideQuotes && nextCharacter === '"') {
                currentCell += '"';
                index += 1;
            } else insideQuotes = !insideQuotes;
            continue;
        }
        if (character === delimiter && !insideQuotes) {
            currentRow.push(currentCell);
            currentCell = '';
            continue;
        }
        if ((character === '\n' || character === '\r') && !insideQuotes) {
            if (character === '\r' && nextCharacter === '\n') index += 1;
            currentRow.push(currentCell);
            if (currentRow.some((cell)=>cell.trim() !== '')) rows.push(currentRow);
            currentCell = '';
            currentRow = [];
            continue;
        }
        currentCell += character;
    }
    if (currentCell.length > 0 || currentRow.length > 0) {
        currentRow.push(currentCell);
        if (currentRow.some((cell)=>cell.trim() !== '')) rows.push(currentRow);
    }
    return rows.map((row)=>row.map((cell)=>cell.trim()));
}
function $b547c8d8406f682e$var$detectHeaderRow(firstRow) {
    const normalized = firstRow.map($b547c8d8406f682e$var$normalizeHeader);
    return normalized.some((header)=>Object.values($b547c8d8406f682e$var$HEADER_ALIASES).some((aliases)=>aliases.includes(header)));
}
function $b547c8d8406f682e$var$matchColumn(headers, key) {
    const aliases = $b547c8d8406f682e$var$HEADER_ALIASES[key];
    const normalizedHeaders = headers.map($b547c8d8406f682e$var$normalizeHeader);
    const matchIndex = normalizedHeaders.findIndex((header)=>aliases.includes(header));
    return matchIndex === -1 ? null : matchIndex;
}
function $b547c8d8406f682e$var$buildAttendees(rows) {
    if (!rows.length) throw new Error('The CSV file is empty.');
    const hasHeader = $b547c8d8406f682e$var$detectHeaderRow(rows[0]);
    const maxColumnCount = rows.reduce((largest, row)=>Math.max(largest, row.length), 0);
    const headers = hasHeader ? rows[0] : maxColumnCount >= 4 ? [
        'first name',
        'last name',
        'pronoms',
        'role'
    ] : [
        'first name',
        'last name',
        'role'
    ];
    const dataRows = hasHeader ? rows.slice(1) : rows;
    const firstNameIndex = $b547c8d8406f682e$var$matchColumn(headers, 'firstName');
    const lastNameIndex = $b547c8d8406f682e$var$matchColumn(headers, 'lastName');
    const pronounsIndex = $b547c8d8406f682e$var$matchColumn(headers, 'pronouns');
    const roleIndex = $b547c8d8406f682e$var$matchColumn(headers, 'role');
    const resolvedFirstNameIndex = firstNameIndex === null ? 0 : firstNameIndex;
    const resolvedLastNameIndex = lastNameIndex === null ? 1 : lastNameIndex;
    const resolvedPronounsIndex = pronounsIndex;
    const resolvedRoleIndex = roleIndex;
    if (resolvedFirstNameIndex === null || resolvedLastNameIndex === null) throw new Error('The CSV must contain first name and last name columns.');
    const attendees = dataRows.map((row, rowIndex)=>{
        const firstName = row[resolvedFirstNameIndex] || '';
        const lastName = row[resolvedLastNameIndex] || '';
        const pronouns = resolvedPronounsIndex === null ? '' : row[resolvedPronounsIndex] || '';
        const role = resolvedRoleIndex === null ? '' : row[resolvedRoleIndex] || '';
        if (!firstName.trim() && !lastName.trim()) return null;
        return {
            id: `${rowIndex + 1}`,
            firstName: $b547c8d8406f682e$var$titleCase(firstName.trim()),
            lastName: $b547c8d8406f682e$var$titleCase(lastName.trim()),
            pronouns: pronouns.trim(),
            role: role.trim()
        };
    }).filter(Boolean);
    const sortedAttendees = $b547c8d8406f682e$var$sortAttendees(attendees);
    if (!sortedAttendees.length) throw new Error('No valid attendee rows were found in the CSV.');
    return {
        attendees: sortedAttendees,
        columns: {
            firstName: headers[resolvedFirstNameIndex] || 'first name',
            lastName: headers[resolvedLastNameIndex] || 'last name',
            pronouns: resolvedPronounsIndex === null ? null : headers[resolvedPronounsIndex],
            role: resolvedRoleIndex === null ? null : headers[resolvedRoleIndex]
        },
        hasHeader: hasHeader
    };
}
function $b547c8d8406f682e$var$renderDetectedColumns(columns, hasHeader) {
    const modeText = hasHeader ? 'Header row detected.' : 'No header row detected. Using column order.';
    const pronounsText = columns.pronouns ? `"${columns.pronouns}"` : 'not provided';
    const roleText = columns.role ? `"${columns.role}"` : 'not provided';
    $b547c8d8406f682e$var$elements.detectedColumns.innerHTML = `
    <strong>${$b547c8d8406f682e$var$escapeHtml(modeText)}</strong>
    First name: "${$b547c8d8406f682e$var$escapeHtml(columns.firstName)}"
    <span aria-hidden="true">\u{2022}</span>
    Last name: "${$b547c8d8406f682e$var$escapeHtml(columns.lastName)}"
    <span aria-hidden="true">\u{2022}</span>
    Pronoms: ${$b547c8d8406f682e$var$escapeHtml(pronounsText)}
    <span aria-hidden="true">\u{2022}</span>
    Role: ${$b547c8d8406f682e$var$escapeHtml(roleText)}
  `;
}
function $b547c8d8406f682e$var$renderMetrics(attendees) {
    const withRole = attendees.filter((attendee)=>attendee.role).length;
    const withoutRole = attendees.length - withRole;
    $b547c8d8406f682e$var$elements.metricTotal.textContent = `${attendees.length}`;
    $b547c8d8406f682e$var$elements.metricWithRole.textContent = `${withRole}`;
    $b547c8d8406f682e$var$elements.metricWithoutRole.textContent = `${withoutRole}`;
}
function $b547c8d8406f682e$var$renderPreview(attendees) {
    $b547c8d8406f682e$var$elements.previewTableBody.innerHTML = attendees.map((attendee, index)=>`
    <tr>
      <td>${index + 1}</td>
      <td>${$b547c8d8406f682e$var$escapeHtml($b547c8d8406f682e$var$getDisplayName(attendee))}</td>
      <td>${$b547c8d8406f682e$var$escapeHtml(attendee.role || "\u2014")}</td>
    </tr>
  `).join('');
}
function $b547c8d8406f682e$var$renderPrintGrid(attendees) {
    const format = $b547c8d8406f682e$var$getSelectedFormat();
    const paddedAttendees = [
        ...Array.from({
            length: $b547c8d8406f682e$var$state.stickerOffset
        }, ()=>null),
        ...attendees
    ];
    const pages = $b547c8d8406f682e$var$chunkAttendees(paddedAttendees, format.perSheet);
    const labelWidth = $b547c8d8406f682e$var$getAdjustedDimension(format.labelWidth, $b547c8d8406f682e$var$state.labelWidthAdjust);
    const labelHeight = $b547c8d8406f682e$var$getAdjustedDimension(format.labelHeight, $b547c8d8406f682e$var$state.labelHeightAdjust);
    const columnGap = `${$b547c8d8406f682e$var$state.columnGapMm}mm`;
    const rowGap = `${$b547c8d8406f682e$var$state.rowGapMm}mm`;
    const nameFontSize = `${$b547c8d8406f682e$var$state.nameFontSize}px`;
    const pronounsFontSize = `${$b547c8d8406f682e$var$state.pronounsFontSize}px`;
    const roleFontSize = `${$b547c8d8406f682e$var$state.roleFontSize}px`;
    const gridMarkup = pages.map((page)=>{
        const labels = Array.from({
            length: format.perSheet
        }, (_, index)=>{
            const attendee = page[index];
            if (!attendee) return '<article class="csv-label csv-label-empty" aria-hidden="true"></article>';
            return `
				<article class="csv-label">
					<div class="csv-label-content">
						<div class="csv-label-name">${$b547c8d8406f682e$var$escapeHtml($b547c8d8406f682e$var$getDisplayName(attendee))}</div>
						${attendee.pronouns ? `<div class="csv-label-pronouns">${$b547c8d8406f682e$var$escapeHtml($b547c8d8406f682e$var$getDisplayPronouns(attendee))}</div>` : ''}
						${attendee.role ? `<div class="csv-label-role">${$b547c8d8406f682e$var$escapeHtml(attendee.role)}</div>` : ''}
					</div>
				</article>
			`;
        }).join('');
        return `
			<section class="csv-label-page">
				<div
					class="csv-label-sheet"
					style="
						--csv-page-width: ${format.pageWidth};
						--csv-page-height: ${format.pageHeight};
						--csv-sheet-padding: ${format.sheetPadding};
						--csv-sheet-offset-x: ${$b547c8d8406f682e$var$state.sheetOffsetX}mm;
						--csv-sheet-offset-y: ${$b547c8d8406f682e$var$state.sheetOffsetY}mm;
						--csv-label-columns: ${format.columns};
						--csv-label-width: ${labelWidth};
						--csv-label-height: ${labelHeight};
						--csv-label-column-gap: ${columnGap};
						--csv-label-row-gap: ${rowGap};
						--csv-label-padding: ${format.labelPadding};
						--csv-label-content-gap: ${format.labelContentGap};
						--csv-label-offset-x: ${format.labelOffsetX};
						--csv-label-offset-y: ${format.labelOffsetY};
						--csv-label-name-size: ${nameFontSize};
						--csv-label-pronouns-size: ${pronounsFontSize};
						--csv-label-role-size: ${roleFontSize};
						--csv-label-border-color: ${$b547c8d8406f682e$var$state.showBorders ? '#cdd4e3' : 'transparent'};
						--csv-label-print-border-color: ${$b547c8d8406f682e$var$state.showBorders ? '#b8b8b8' : 'transparent'};
					"
				>${labels}</div>
			</section>
			`;
    }).join('');
    $b547c8d8406f682e$var$elements.printGrid.innerHTML = gridMarkup;
}
function $b547c8d8406f682e$var$applyCurrentSettingsToUi() {
    $b547c8d8406f682e$var$syncSettingsInputs();
    $b547c8d8406f682e$var$persistSettings();
    if ($b547c8d8406f682e$var$state.attendees.length) $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
}
function $b547c8d8406f682e$var$setStatus(message, type = 'idle') {
    if (!$b547c8d8406f682e$var$elements.status) return;
    $b547c8d8406f682e$var$elements.status.textContent = message;
    $b547c8d8406f682e$var$elements.status.dataset.state = type;
}
function $b547c8d8406f682e$var$setButtonsEnabled(isEnabled) {
    $b547c8d8406f682e$var$elements.printButton.disabled = !isEnabled;
}
function $b547c8d8406f682e$var$resetOutput() {
    $b547c8d8406f682e$var$state.attendees = [];
    $b547c8d8406f682e$var$state.columns = {
        firstName: null,
        lastName: null,
        pronouns: null,
        role: null
    };
    $b547c8d8406f682e$var$state.fileName = '';
    $b547c8d8406f682e$var$state.formatId = $b547c8d8406f682e$var$elements.formatSelect.value;
    $b547c8d8406f682e$var$elements.fileInput.value = '';
    $b547c8d8406f682e$var$elements.fileNamePill.textContent = 'No file loaded';
    $b547c8d8406f682e$var$elements.metricTotal.textContent = '0';
    $b547c8d8406f682e$var$elements.metricWithRole.textContent = '0';
    $b547c8d8406f682e$var$elements.metricWithoutRole.textContent = '0';
    $b547c8d8406f682e$var$elements.detectedColumns.textContent = 'Waiting for a file to detect columns.';
    $b547c8d8406f682e$var$elements.previewTableBody.innerHTML = `
    <tr class="csv-empty-row">
      <td colspan="3">No data loaded yet.</td>
    </tr>
  `;
    $b547c8d8406f682e$var$elements.printGrid.innerHTML = `
    <div class="csv-print-empty">
      Import a CSV file to generate printable sticker sheets.
    </div>
  `;
    $b547c8d8406f682e$var$setButtonsEnabled(false);
}
async function $b547c8d8406f682e$var$handleFile(file) {
    if (!file) return;
    try {
        const text = await file.text();
        const rows = $b547c8d8406f682e$var$parseCsv(text);
        const result = $b547c8d8406f682e$var$buildAttendees(rows);
        $b547c8d8406f682e$var$state.attendees = result.attendees;
        $b547c8d8406f682e$var$state.columns = result.columns;
        $b547c8d8406f682e$var$state.fileName = file.name;
        $b547c8d8406f682e$var$elements.fileNamePill.textContent = file.name;
        $b547c8d8406f682e$var$renderMetrics(result.attendees);
        $b547c8d8406f682e$var$renderDetectedColumns(result.columns, result.hasHeader);
        $b547c8d8406f682e$var$renderPreview(result.attendees);
        $b547c8d8406f682e$var$renderPrintGrid(result.attendees);
        $b547c8d8406f682e$var$setStatus(`${result.attendees.length} names imported and sorted alphabetically for ${$b547c8d8406f682e$var$getSelectedFormat().label}.`, 'success');
        $b547c8d8406f682e$var$setButtonsEnabled(true);
    } catch (error) {
        $b547c8d8406f682e$var$resetOutput();
        $b547c8d8406f682e$var$elements.fileNamePill.textContent = file.name;
        $b547c8d8406f682e$var$setStatus(error.message || 'The CSV file could not be processed.', 'error');
    }
}
function $b547c8d8406f682e$var$handleTemplateChange() {
    $b547c8d8406f682e$var$state.formatId = $b547c8d8406f682e$var$elements.formatSelect.value;
    $b547c8d8406f682e$var$state.columnGapMm = $b547c8d8406f682e$var$getMillimeterValue($b547c8d8406f682e$var$getSelectedFormat().columnGap);
    $b547c8d8406f682e$var$state.rowGapMm = $b547c8d8406f682e$var$getMillimeterValue($b547c8d8406f682e$var$getSelectedFormat().rowGap);
    $b547c8d8406f682e$var$state.nameFontSize = $b547c8d8406f682e$var$getPixelValue($b547c8d8406f682e$var$getSelectedFormat().nameFontSize);
    $b547c8d8406f682e$var$state.pronounsFontSize = $b547c8d8406f682e$var$getPixelValue($b547c8d8406f682e$var$getSelectedFormat().pronounsFontSize);
    $b547c8d8406f682e$var$state.roleFontSize = $b547c8d8406f682e$var$getPixelValue($b547c8d8406f682e$var$getSelectedFormat().roleFontSize);
    $b547c8d8406f682e$var$syncSettingsInputs();
    $b547c8d8406f682e$var$persistSettings();
    if ($b547c8d8406f682e$var$state.attendees.length) {
        $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
        $b547c8d8406f682e$var$setStatus(`${$b547c8d8406f682e$var$state.attendees.length} names ready for ${$b547c8d8406f682e$var$getSelectedFormat().label}.`, 'success');
    }
}
function $b547c8d8406f682e$var$handleStickerOffsetChange() {
    $b547c8d8406f682e$var$state.stickerOffset = $b547c8d8406f682e$var$getStickerOffsetValue($b547c8d8406f682e$var$elements.stickerOffsetInput.value);
    $b547c8d8406f682e$var$syncSettingsInputs();
    if ($b547c8d8406f682e$var$state.attendees.length) {
        $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
        $b547c8d8406f682e$var$setStatus(`${$b547c8d8406f682e$var$state.attendees.length} names ready for ${$b547c8d8406f682e$var$getSelectedFormat().label} starting after ${$b547c8d8406f682e$var$state.stickerOffset} used sticker${$b547c8d8406f682e$var$state.stickerOffset === 1 ? '' : 's'}.`, 'success');
    }
}
function $b547c8d8406f682e$var$handleApplySavedSettings() {
    const selectedPresetName = $b547c8d8406f682e$var$elements.savedSettingsSelect.value;
    const selectedPreset = $b547c8d8406f682e$var$state.savedPresets.find((preset)=>preset.name === selectedPresetName);
    if (!selectedPreset) return;
    $b547c8d8406f682e$var$setSettingsFromPayload(selectedPreset.settings);
    $b547c8d8406f682e$var$applyCurrentSettingsToUi();
    $b547c8d8406f682e$var$setStatus(`Applied saved setup "${selectedPreset.name}".`, 'success');
}
function $b547c8d8406f682e$var$handleSheetOffsetChange() {
    $b547c8d8406f682e$var$state.sheetOffsetX = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.sheetOffsetXInput.value);
    $b547c8d8406f682e$var$state.sheetOffsetY = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.sheetOffsetYInput.value);
    $b547c8d8406f682e$var$persistSettings();
    if ($b547c8d8406f682e$var$state.attendees.length) {
        $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
        $b547c8d8406f682e$var$setStatus(`${$b547c8d8406f682e$var$state.attendees.length} names ready for ${$b547c8d8406f682e$var$getSelectedFormat().label} with ${$b547c8d8406f682e$var$state.sheetOffsetX}mm horizontal and ${$b547c8d8406f682e$var$state.sheetOffsetY}mm vertical calibration.`, 'success');
    }
}
function $b547c8d8406f682e$var$handleLabelSizeChange() {
    $b547c8d8406f682e$var$state.labelWidthAdjust = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.labelWidthAdjustInput.value);
    $b547c8d8406f682e$var$state.labelHeightAdjust = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.labelHeightAdjustInput.value);
    $b547c8d8406f682e$var$persistSettings();
    if ($b547c8d8406f682e$var$state.attendees.length) {
        $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
        $b547c8d8406f682e$var$setStatus(`${$b547c8d8406f682e$var$state.attendees.length} names ready for ${$b547c8d8406f682e$var$getSelectedFormat().label} with ${$b547c8d8406f682e$var$state.labelWidthAdjust}mm width and ${$b547c8d8406f682e$var$state.labelHeightAdjust}mm height adjustment.`, 'success');
    }
}
function $b547c8d8406f682e$var$handleSpacingChange() {
    $b547c8d8406f682e$var$state.columnGapMm = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.columnGapInput.value);
    $b547c8d8406f682e$var$state.rowGapMm = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.rowGapInput.value);
    $b547c8d8406f682e$var$persistSettings();
    if ($b547c8d8406f682e$var$state.attendees.length) {
        $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
        $b547c8d8406f682e$var$setStatus(`${$b547c8d8406f682e$var$state.attendees.length} names ready for ${$b547c8d8406f682e$var$getSelectedFormat().label} with ${$b547c8d8406f682e$var$state.columnGapMm}mm horizontal and ${$b547c8d8406f682e$var$state.rowGapMm}mm vertical spacing.`, 'success');
    }
}
function $b547c8d8406f682e$var$handleTextSizeChange() {
    $b547c8d8406f682e$var$state.nameFontSize = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.nameFontSizeInput.value);
    $b547c8d8406f682e$var$state.pronounsFontSize = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.pronounsFontSizeInput.value);
    $b547c8d8406f682e$var$state.roleFontSize = $b547c8d8406f682e$var$getSheetOffsetValue($b547c8d8406f682e$var$elements.roleFontSizeInput.value);
    $b547c8d8406f682e$var$persistSettings();
    if ($b547c8d8406f682e$var$state.attendees.length) {
        $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
        $b547c8d8406f682e$var$setStatus(`${$b547c8d8406f682e$var$state.attendees.length} names ready for ${$b547c8d8406f682e$var$getSelectedFormat().label} with ${$b547c8d8406f682e$var$state.nameFontSize}px name text, ${$b547c8d8406f682e$var$state.pronounsFontSize}px pronoms text, and ${$b547c8d8406f682e$var$state.roleFontSize}px role text size.`, 'success');
    }
}
function $b547c8d8406f682e$var$handleBorderToggleChange() {
    $b547c8d8406f682e$var$state.showBorders = $b547c8d8406f682e$var$elements.showBordersInput.checked;
    $b547c8d8406f682e$var$persistSettings();
    if ($b547c8d8406f682e$var$state.attendees.length) {
        $b547c8d8406f682e$var$renderPrintGrid($b547c8d8406f682e$var$state.attendees);
        $b547c8d8406f682e$var$setStatus(`${$b547c8d8406f682e$var$state.attendees.length} names ready for ${$b547c8d8406f682e$var$getSelectedFormat().label} with sticker borders ${$b547c8d8406f682e$var$state.showBorders ? 'enabled' : 'disabled'}.`, 'success');
    }
}
function $b547c8d8406f682e$var$handleSavedPresetSelectionChange() {
    $b547c8d8406f682e$var$elements.applySettingsButton.disabled = !$b547c8d8406f682e$var$elements.savedSettingsSelect.value;
}
function $b547c8d8406f682e$var$openSaveSettingsDialog() {
    $b547c8d8406f682e$var$elements.saveSettingsNameInput.value = $b547c8d8406f682e$var$elements.savedSettingsSelect.value || '';
    if (typeof $b547c8d8406f682e$var$elements.saveSettingsDialog.showModal === 'function') $b547c8d8406f682e$var$elements.saveSettingsDialog.showModal();
    $b547c8d8406f682e$var$elements.saveSettingsNameInput.focus();
    /* istanbul ignore next */ $b547c8d8406f682e$var$elements.saveSettingsNameInput.select();
}
function $b547c8d8406f682e$var$closeSaveSettingsDialog() {
    if (typeof $b547c8d8406f682e$var$elements.saveSettingsDialog.close === 'function') $b547c8d8406f682e$var$elements.saveSettingsDialog.close();
}
function $b547c8d8406f682e$var$handleSaveSettingsSubmit(event) {
    event.preventDefault();
    const presetName = $b547c8d8406f682e$var$elements.saveSettingsNameInput.value.trim();
    if (!presetName) {
        $b547c8d8406f682e$var$elements.saveSettingsNameInput.focus();
        return;
    }
    const presetIndex = $b547c8d8406f682e$var$state.savedPresets.findIndex((preset)=>preset.name === presetName);
    const presetPayload = {
        name: presetName,
        settings: $b547c8d8406f682e$var$getSettingsPayload()
    };
    if (presetIndex === -1) $b547c8d8406f682e$var$state.savedPresets.push(presetPayload);
    else $b547c8d8406f682e$var$state.savedPresets[presetIndex] = presetPayload;
    $b547c8d8406f682e$var$persistSavedPresets();
    $b547c8d8406f682e$var$renderSavedPresetOptions();
    $b547c8d8406f682e$var$elements.savedSettingsSelect.value = presetName;
    $b547c8d8406f682e$var$elements.applySettingsButton.disabled = false;
    $b547c8d8406f682e$var$closeSaveSettingsDialog();
    $b547c8d8406f682e$var$setStatus(`Saved setup "${presetName}".`, 'success');
}
function $b547c8d8406f682e$var$bindDragAndDrop() {
    [
        'dragenter',
        'dragover'
    ].forEach((eventName)=>{
        $b547c8d8406f682e$var$elements.dropzone.addEventListener(eventName, (event)=>{
            event.preventDefault();
            $b547c8d8406f682e$var$elements.dropzone.classList.add('is-dragging');
        });
    });
    [
        'dragleave',
        'drop'
    ].forEach((eventName)=>{
        $b547c8d8406f682e$var$elements.dropzone.addEventListener(eventName, (event)=>{
            event.preventDefault();
            $b547c8d8406f682e$var$elements.dropzone.classList.remove('is-dragging');
        });
    });
    $b547c8d8406f682e$var$elements.dropzone.addEventListener('drop', (event)=>{
        const [file] = event.dataTransfer.files;
        $b547c8d8406f682e$var$handleFile(file);
    });
}
$b547c8d8406f682e$var$elements.fileInput.addEventListener('change', (event)=>{
    const [file] = event.target.files;
    $b547c8d8406f682e$var$handleFile(file);
});
$b547c8d8406f682e$var$elements.formatSelect.addEventListener('change', $b547c8d8406f682e$var$handleTemplateChange);
$b547c8d8406f682e$var$elements.sheetOffsetXInput.addEventListener('input', $b547c8d8406f682e$var$handleSheetOffsetChange);
$b547c8d8406f682e$var$elements.sheetOffsetYInput.addEventListener('input', $b547c8d8406f682e$var$handleSheetOffsetChange);
$b547c8d8406f682e$var$elements.labelWidthAdjustInput.addEventListener('input', $b547c8d8406f682e$var$handleLabelSizeChange);
$b547c8d8406f682e$var$elements.labelHeightAdjustInput.addEventListener('input', $b547c8d8406f682e$var$handleLabelSizeChange);
$b547c8d8406f682e$var$elements.stickerOffsetInput.addEventListener('input', $b547c8d8406f682e$var$handleStickerOffsetChange);
$b547c8d8406f682e$var$elements.columnGapInput.addEventListener('input', $b547c8d8406f682e$var$handleSpacingChange);
$b547c8d8406f682e$var$elements.rowGapInput.addEventListener('input', $b547c8d8406f682e$var$handleSpacingChange);
$b547c8d8406f682e$var$elements.nameFontSizeInput.addEventListener('input', $b547c8d8406f682e$var$handleTextSizeChange);
$b547c8d8406f682e$var$elements.pronounsFontSizeInput.addEventListener('input', $b547c8d8406f682e$var$handleTextSizeChange);
$b547c8d8406f682e$var$elements.roleFontSizeInput.addEventListener('input', $b547c8d8406f682e$var$handleTextSizeChange);
$b547c8d8406f682e$var$elements.showBordersInput.addEventListener('change', $b547c8d8406f682e$var$handleBorderToggleChange);
$b547c8d8406f682e$var$elements.savedSettingsSelect.addEventListener('change', $b547c8d8406f682e$var$handleSavedPresetSelectionChange);
$b547c8d8406f682e$var$elements.applySettingsButton.addEventListener('click', $b547c8d8406f682e$var$handleApplySavedSettings);
$b547c8d8406f682e$var$elements.saveSettingsButton.addEventListener('click', $b547c8d8406f682e$var$openSaveSettingsDialog);
$b547c8d8406f682e$var$elements.saveSettingsForm.addEventListener('submit', $b547c8d8406f682e$var$handleSaveSettingsSubmit);
$b547c8d8406f682e$var$elements.cancelSaveSettingsButton.addEventListener('click', $b547c8d8406f682e$var$closeSaveSettingsDialog);
$b547c8d8406f682e$var$elements.printButton.addEventListener('click', ()=>window.print());
$b547c8d8406f682e$var$bindDragAndDrop();
$b547c8d8406f682e$var$restoreSavedPresets();
$b547c8d8406f682e$var$restoreSettings();
$b547c8d8406f682e$var$resetOutput();


export {$b547c8d8406f682e$exports as default};
//# sourceMappingURL=csv-name-printer.4175af2a.js.map
